import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Switch } from '_components';
import { _ } from '_locales';
import { colors } from '_styles';
import styled, { css } from 'styled-components';
import parse from 'html-react-parser';
import ErrorText from './ErrorText';

// Styles
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Container = styled.div`
  padding: 0 40px;
`;

const Title = styled.h2`
  font-size: 20px !important;
  text-align: left !important;
  margin-bottom: 40px;
  font-weight: 500 !important;
`;

const CollectionsContainer = styled.div`
  flex-basis: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  ${(parentWidth < 581) && css`
    display: inherit;
  `};
`;

const CollItem = styled.div`
  width: 40%;
  font-size: 16px !important;
   
  font-weight: 500 !important;
  display: flex;
  margin-bottom: 22px;

  ${(parentWidth < 581) && css`
    width: 100%;
  `};
`;

const CollItemText = styled.span`
  vertical-align: ${(props) => (props.isText ? ('middle') : ('none'))};
  flex: 1;
  margin-right: 10px;
  text-align: left !important;
`;
// End of styles

const Collections = ({ allCollections }) => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <Container>
      <Title>
        {_('reminder.what_type_off_collection')}
      </Title>
      <CollectionsContainer>
        {
          allCollections
            && Object.keys(allCollections)
            ? (
              Object.entries(allCollections)
                .map(([val, collection]) => (
                  <CollItem title={collection.title} key={val}>
                    <CollItemText>
                      {parse(collection.title)}
                    </CollItemText>
                    <Switch
                      aria-label={`${collection.title} Switch`}
                      variant="multi"
                      name="collections"
                      value={val.slice(11)}
                      switchRef={register}
                      id={collection.oidx}
                      labelBgColor={colors.LIGHT_GREY}
                      inputBgColor={colors.RC_ACTION}
                    />
                  </CollItem>
                ))) : null
        }
        <CollItem style={{ display: 'none' }} title="">
          <Switch
            variant="multi"
            name="collections"
            value="1"
            switchRef={register}
            id={999999999999}
            labelBgColor={colors.LIGHT_GREY}
            inputBgColor={colors.RC_ACTION}
          />
        </CollItem>
      </CollectionsContainer>
      {
        errors.collections && (
          <ErrorText>{errors.collections.message}</ErrorText>
        )
      }
    </Container>
  );
};

export default Collections;
